export default {
  countryRegister: {
    type: String,
    default: null
  },
  type: {
    type: String,
    default: null
  },
  totalAgendas: {
    type: Number,
    default: 0
  },
  totalAgendaSchedules: {
    type: Number,
    default: 0
  },
  totalProfessional: {
    type: Number,
    default: 0
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/statistics/resources/props.js